var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.658,
    height: 13.466,
    viewBox: "0 0 15.658 13.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M-174.4-.7h-14.3l2.192,4.071v8.142a1.294,1.294,0,0,0,1.357,1.253H-174.4a1.294,1.294,0,0,0,1.357-1.253V.761A1.477,1.477,0,0,0-174.4-.7Zm-4.176,10.126h-5.219V8.382h5.219Zm2.088-3.132h-7.307V5.25h7.307Zm1.044-3.132h-8.351V2.118h8.351Z",
    transform: "translate(188.7 0.7)",
    fill: "#D6DBDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyComment);
export default __webpack_public_path__ + "static/media/icon-empty-comment.e45ff1334523ec234b451d594d8c2ce7.svg";
export { ForwardRef as ReactComponent };